import React, { forwardRef } from 'react';
const CardActions = forwardRef(function CardActions({ testId = 'store-card-actions', children, ...otherProps }, ref) {
    return (React.createElement("div", Object.assign({ ref: ref, "data-card-actions": true, "data-testid": testId }, otherProps), children));
});
export default CardActions;
//# sourceMappingURL=CardActions.js.map